module.exports = __webpack_public_path__ + "img/logo-black.752196af.png";